import { Movax } from './Movax';
import { MainNavigation } from './MainNavigation';

// jquery does not currently support es6 way of importing so we need to do it old school
var $ = require('jquery');

/**
 * create fixed navigation
 * @class
 */
class FixedNavigation {

  private jsBlock: string;
  private block: string;
  private fixedClass: string;

  private $block;
  private $fixedElement;

  private fixedElementPosition: Object;

  private _isFixed: boolean;
  private _isShown: boolean;

  private lastScrollPosition: number;
  private scrollTreshold: number;
  private mainNavigation: MainNavigation;

  /**
   * @param {string} blockId [e.g. 'main-nav']
   * @param {string} fixedElement [e.g. 'inner' (id="js-main-nav__inner"), this gets fixed when scrolled enough]
   */
  constructor(blockId: string, fixedElement: string) {
    var fixedElementId: string;

    this.jsBlock = 'js-' + blockId;
    this.block = blockId;
    this.fixedClass = this.block + '__' + fixedElement + '--fixed';

    fixedElementId = '#' + this.jsBlock + '__' + fixedElement;
    this.$block = $('#' + this.jsBlock);
    this.$fixedElement = $(fixedElementId);

    // If element is not found, return
    if(!this.$block.length) {
      return;
    }

    this.scrollTreshold = 25;

    this.fixedElementPosition = {
      'left': null,
      'top': null
    };

    this._isFixed = false;
    this._isShown = false;

    // Only throw error if fixedElement is not found so that we can use this class safely on all pages
    if(this.$block) {
      if (!this.$fixedElement) {
        throw new Error('FixedNavigation#constructor: fixedElement (' + fixedElementId + ') not found in DOM');
      }

      Movax.events.addScrollSubscriber(this._scrollSubscriber.bind(this));
      //Movax.breakpoints.addChangeSubscriber(this._breakpointChangeSubscriber.bind(this), )
    }

    this.mainNavigation = new MainNavigation('main-nav');
    this.mainNavigation.init();

  }

  private _scrollSubscriber(position) {
    var block = this.$block[0],
        scrollDir;

    // Do we need to set nav fixed:
    if (block.getBoundingClientRect().top + this.getHeight() <= 0) {
      this._setFixed(block.getBoundingClientRect().top);
    } else if (block.getBoundingClientRect().top >= 0) {
      this._removeFixed();
    }

    if (this.lastScrollPosition && this.lastScrollPosition > position.top) {
      scrollDir = 'up';
    } else {
      scrollDir = 'down';
    }

    // Only trigger once the threshold is met, or for initial positioning
    if (!this.lastScrollPosition || (scrollDir === 'down' && this.lastScrollPosition + this.scrollTreshold < position.top) || (scrollDir === 'up' && this.lastScrollPosition - this.scrollTreshold > position.top)) {

      this.lastScrollPosition = position.top;

      // If we're not fixed, don't position
      if (!this.isFixed()) {
        return;
      }

      if (scrollDir === 'down') {
        this._isShown = false;
        this.$fixedElement.css({ 'top': -this.getHeight() + 'px' });
        this.mainNavigation.closeDropdowns();

      } else if (scrollDir === 'up') {
        this._isShown = true;
        this.$fixedElement.css({ 'top': '0px' });
      }

    }
  }

  private _setFixed(elementTop:number) {
    var self = this;

    if(this._isFixed) {
      return;
    }

    this._isFixed = true;

    // set correct height to container
    this.$block.css({
      height: this.$fixedElement[0].offsetHeight + 'px',
    });

    this.$fixedElement.css({
      top: elementTop + 'px'
    });

    Movax.dom.waitForStyles(this.$fixedElement[0], {
      'top': elementTop + 'px'
    }).then(function() {

      // add fixed class
      self.$fixedElement.addClass(self.fixedClass);

      // when class is found set top to final position

      Movax.dom.waitForClass(self.fixedClass, self.$fixedElement[0]).then(() => {
        /*self.$fixedElement.css({
          'top': '0px'
        });*/
      });

      // Hide the automatically opened child drop down
      self.$fixedElement.find('.' + self.block + '__li--is-open').removeClass(self.block + '__li--is-open');
    });
  }

  private _removeFixed() {
    if (!this.isFixed) {
      return;
    }

    this._isFixed = false;

    // set auto height to container
    this.$block.css({
      height: ''
    });

    // And position nav properly
    this.$fixedElement.css({
      top: '',
    });

    this.$fixedElement.removeClass(this.fixedClass);
  }

  public isFixed() {
    return this._isFixed;
  }

  public isShown() {
    return this._isShown;
  }

  public getHeight() {
    return this.$fixedElement.length ? this.$fixedElement.outerHeight() : 0;
  }
}

var fixedNavigation = new FixedNavigation('main-nav', 'inner');

export {fixedNavigation as FixedNavigation };
